import { render, staticRenderFns } from "./PageParametersView.vue?vue&type=template&id=50525654"
import script from "./PageParametersView.vue?vue&type=script&lang=js"
export * from "./PageParametersView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50525654')) {
      api.createRecord('50525654', component.options)
    } else {
      api.reload('50525654', component.options)
    }
    module.hot.accept("./PageParametersView.vue?vue&type=template&id=50525654", function () {
      api.rerender('50525654', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pageParameters/PageParametersView.vue"
export default component.exports